import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	stageList: [],
	taskList: []
};

const taskConfigurationSlice = createSlice({
	name: 'taskConfigurationSlice',
	initialState,
	reducers: {
		getStageList: (state, { payload = [] }) => {
			state.taskList = payload;
			const stageList = payload.reduce((acc, task) => {
				const stage = task.productDevelopmentStageResponse;
				const existingStage = acc.find((s) => s.stageId === stage.id);

				if (existingStage) {
					existingStage.taskResponse.push(task);
				} else {
					acc.push({
						stageName: stage.name,
						stageId: stage.id,
						taskResponse: [task]
					});
				}

				return acc;
			}, []);

			state.stageList = stageList;
		}
	}
});

export const { getStageList } = taskConfigurationSlice.actions;

export default taskConfigurationSlice.reducer;
